import config from "./_apiConfig/apiConfig";
import { apiRequest, apiEndPoints, methodType } from "./_apiConfig";

export const getApplicationsList = async (data = {}) => {
  return apiRequest(
    methodType.GET,
    apiEndPoints.applicationsList,
    data,
    true
  );
};

